import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { AnimatePresence, motion } from "framer-motion";
import { RotateCcw } from "lucide-react";
import Envelope from "@/components/Envelope";
import Invitation from "@/components/Invitation";
import AudioPlayer from "@/components/AudioPlayer";
import FamilyPage from "@/components/FamilyPage";
import { Toaster } from "@/components/ui/sonner";

const AUTO_OPEN_MS = 20000;

function App() {
  const [stage, setStage] = useState("sealed");

  const open = useCallback(
    () => setStage((s) => (s === "sealed" ? "opening" : s)),
    [],
  );
  const replay = useCallback(() => {
    window.scrollTo(0, 0);
    setStage("sealed");
  }, []);

  useEffect(() => {
    if (stage !== "sealed") return undefined;
    const t = setTimeout(open, AUTO_OPEN_MS);
    return () => clearTimeout(t);
  }, [stage, open]);

  useEffect(() => {
    document.body.style.overflow = stage === "opened" ? "" : "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [stage]);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      {window.location.pathname === "/family" ? (
        <FamilyPage />
      ) : (
        <>
          {stage !== "sealed" && <Invitation revealed={stage === "opened"} />}
          <AnimatePresence>
            {stage !== "opened" && (
              <Envelope
                key="envelope"
                opening={stage === "opening"}
                onOpen={open}
                onOpened={() => setStage("opened")}
              />
            )}
          </AnimatePresence>
          {stage === "opened" && (
            <>
              <AudioPlayer autoplay />
              <motion.button
                type="button"
                data-testid="replay-button"
                aria-label="Replay the envelope opening"
                onClick={replay}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.4, duration: 0.6 }}
                className="fixed bottom-5 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-[#C5A059]/50 bg-[#4A3B32]/90 text-[#E8D8B0] shadow-lg backdrop-blur transition-colors hover:bg-[#4A3B32]"
              >
                <RotateCcw size={18} />
              </motion.button>
            </>
          )}
        </>
      )}
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
